import { Injectable } from '@angular/core';
import { LoginConnector } from '@b2b/features/login/services/login.connector';
import { Observable } from 'rxjs';
import { CookieService } from '@shared/tools/cookies.service';
import { Router } from '@angular/router';
import { AUTH } from '@shared/tools/constants';
import { UserService } from '@core/user/user.service';
import { ToasterService } from '@shared/components/toaster/toaster.service';
import { TOASTER_TYPE } from '@shared/components/toaster/toaster.model';
import { AuthResponse } from '@app/core/authentication/model/auth.model';

export const ANONYMOUS = 'ANONYMOUS';
export const LOGGED = 'LOGGED';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(
    private loginConnector: LoginConnector,
    private cookieService: CookieService,
    private router: Router,
    private userService: UserService,
    private toasterService: ToasterService,
  ) {}

  login(user: string, pw: string): Observable<AuthResponse> {
    return this.loginConnector.login(user, pw);
  }

  handlerSuccessLogout = () => {
    this.cookieService.deleteCookie(AUTH);
    this.userService.clearUser();
    this.router.navigate(['/login']);
  };

  handlerErrorLogout = () => {
    this.router.navigate(['']);
    return this.toasterService.init({
      id: 'erro-logout',
      type: TOASTER_TYPE.DANGER,
      content: 'Erro no logout',
    });
  };

  logout() {
    this.loginConnector.logout();
  }
}
